import Table from "../../../components/table/Table";
import { useApiClient } from "../../../shared/customHooks";
import { PageHeader } from "../../../components/header/PageHeader";
import CreateApplicationButtonsManager from "../../../components/CreateApplicationButtonsManager";
import { applicationsAllListTable } from "../../../shared/tableObjects/admin/applicationsAllListTable";
import { useState, useEffect } from "react";
import { RoleId } from "../../../shared/enums/Role";

export default function ApplicationsAllList() {
  const apiClient = useApiClient("AdminApplication");
  const headerText = [
    {
      class: "p-0 m-0 flex items-center",
      value: "All Applications",
      icon: "list-icon icon-spec",
    },
  ];

  const { fetchData } = useApiClient("UserManagement", { identity: true });
  const [assessors, setAssessors] = useState<any>({ options: [] });

  useEffect(() => {
    fetchData(`GetActiveUsersByRoles/${RoleId.Assessor},${RoleId.Manager}`).then((res) => {
      const options = (res.data as any[]).map((user) => user.displayName).sort();
      setAssessors(options);
    });
  }, []);

  return (
    <>
      <PageHeader headerText={headerText} hideBreadcrumbs={true} icon={"icon"}></PageHeader>
      <div className="list-table">
        <CreateApplicationButtonsManager />
        <Table apiClient={apiClient} route="allApplications" label={""} columns={applicationsAllListTable("applications", assessors)} />
      </div>
    </>
  );
}
